function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { logger as N } from "../../shared-lib/index.js";
import { getUser as ao } from "../Core/get-user.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as p } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import { keys as y } from "../util/code-utils.js";
export var buildBrazeBridge = function buildBrazeBridge(t, e, o) {
  var n = {
    display: {},
    web: {}
  },
      requestPushPermission = function requestPushPermission() {
    return function () {
      var t = arguments;
      import("../Push/request-push-permission.js").then(function (e) {
        r.nt() ? e.requestPushPermission.apply(e, _toConsumableArray(Array.prototype.slice.call(t))) : N.error(p);
      });
    };
  },
      s = {
    requestImmediateDataFlush: function requestImmediateDataFlush() {
      var t = arguments;
      import("../Core/request-immediate-data-flush.js").then(function (_ref) {
        var requestImmediateDataFlush = _ref.requestImmediateDataFlush;
        r.nt() ? requestImmediateDataFlush.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t))) : N.error(p);
      });
    },
    logCustomEvent: function logCustomEvent() {
      var t = arguments;
      import("../Core/log-custom-event.js").then(function (_ref2) {
        var logCustomEvent = _ref2.logCustomEvent;
        if (!r.nt()) return void N.error(p);
        logCustomEvent.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t)));
      });
    },
    logPurchase: function logPurchase() {
      var t = arguments;
      import("../Core/log-purchase.js").then(function (_ref3) {
        var logPurchase = _ref3.logPurchase;
        if (!r.nt()) return void N.error(p);
        logPurchase.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t)));
      });
    },
    unregisterPush: function unregisterPush() {
      var t = arguments;
      import("../Push/unregister-push.js").then(function (_ref4) {
        var unregisterPush = _ref4.unregisterPush;
        r.nt() ? unregisterPush.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t))) : N.error(p);
      });
    },
    requestPushPermission: requestPushPermission(),
    changeUser: function changeUser() {
      var t = arguments;
      import("../Core/change-user.js").then(function (_ref5) {
        var changeUser = _ref5.changeUser;
        if (!r.nt()) return void N.error(p);
        changeUser.apply(void 0, _toConsumableArray(Array.prototype.slice.call(t)));
      });
    }
  },
      i = function i(t) {
    return function () {
      s[t].apply(s, _toConsumableArray(Array.prototype.slice.call(arguments)));
    };
  };

  var _iterator = _createForOfIteratorHelper(y(s)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t2 = _step.value;
      n[_t2] = i(_t2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var u = ["setFirstName", "setLastName", "setEmail", "setGender", "setDateOfBirth", "setCountry", "setHomeCity", "setEmailNotificationSubscriptionType", "setLanguage", "addAlias", "setPushNotificationSubscriptionType", "setPhoneNumber", "setCustomUserAttribute", "addToCustomAttributeArray", "removeFromCustomAttributeArray", "incrementCustomUserAttribute", "setCustomLocationAttribute", "addToSubscriptionGroup", "removeFromSubscriptionGroup"],
      c = function c(t) {
    return function () {
      var e = ao();
      e && e[t].apply(e, _toConsumableArray(Array.prototype.slice.call(arguments)));
    };
  },
      a = {};

  for (var _t = 0; _t < u.length; _t++) {
    a[u[_t]] = c(u[_t]);
  }

  n.getUser = function () {
    return a;
  };

  var m = {
    showFeed: e
  },
      f = function f(e) {
    return function () {
      var r = arguments;
      "function" != typeof o ? m[e].apply(m, _toConsumableArray(Array.prototype.slice.call(r))) : o(t, function () {
        m[e].apply(m, _toConsumableArray(Array.prototype.slice.call(r)));
      });
    };
  },
      l = n.display;

  var _iterator2 = _createForOfIteratorHelper(y(m)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t3 = _step2.value;
      l[_t3] = f(_t3);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var d = {
    registerAppboyPushMessages: requestPushPermission()
  },
      h = function h(t) {
    return function () {
      d[t].apply(d, _toConsumableArray(Array.prototype.slice.call(arguments)));
    };
  },
      g = n.web;

  var _iterator3 = _createForOfIteratorHelper(y(d)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t4 = _step3.value;
      g[_t4] = h(_t4);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return n;
};
export var applyNonceToDynamicallyCreatedTags = function applyNonceToDynamicallyCreatedTags(t, e, r) {
  var o = "([\\w]+)\\s*=\\s*document.createElement\\(['\"]".concat(r, "['\"]\\)"),
      n = t.match(new RegExp(o));

  if (n) {
    var _r = "".concat(n[1], ".setAttribute(\"nonce\", \"").concat(e, "\")");

    return "".concat(t.slice(0, n.index + n[0].length), ";").concat(_r, ";").concat(t.slice(n.index + n[0].length));
  }

  return null;
};
export var attachHtmlToIframeWithNonce = function attachHtmlToIframeWithNonce(t, e, r) {
  var o = null;

  if (null != r) {
    o = document.createElement("html"), o.innerHTML = e || "";

    var _t5 = o.getElementsByTagName("style");

    for (var _e = 0; _e < _t5.length; _e++) {
      _t5[_e].setAttribute("nonce", r);
    }

    var n = o.getElementsByTagName("script");

    for (var _t6 = 0; _t6 < n.length; _t6++) {
      n[_t6].setAttribute("nonce", r), n[_t6].innerHTML = n[_t6].innerHTML.replace(/<style>/g, "<style nonce='".concat(r, "'>"));

      var _e2 = applyNonceToDynamicallyCreatedTags(n[_t6].innerHTML, r, "script");

      _e2 && (n[_t6].innerHTML = _e2);

      var _o = applyNonceToDynamicallyCreatedTags(n[_t6].innerHTML, r, "style");

      _o && (n[_t6].innerHTML = _o);
    }
  }

  t.srcdoc = o ? o.innerHTML : e || "";
};